import { createApp, ref } from 'vue';
import Parallax from 'scroll-parallax-effect/vue';
import FloatingVue from 'floating-vue';
import mitt from 'mitt';
// import Parallax from './scroll-parallax-effect/dist/scroll-parallax-effect/vue';
import router from './routes';

import 'floating-vue/dist/style.css'
import App from './App.vue';
if(window.location.pathname === '/steal-estate/' || window.location.pathname.search('steal-estate/character') > 0) {
  const emitter = mitt();
  let app = createApp(App)

  app.config.globalProperties.$audioUrl = ref('');
  app.config.globalProperties.$subtitlesUrl = ref('');
  app.config.globalProperties.$cc_on = ref(false);
  app.config.globalProperties.$readMore = ref('');
  app.config.globalProperties.$evidence = ref('[]');
  app.config.globalProperties.emitter = emitter;
  app.config.globalProperties.$navigate = ref(false);
  app.config.globalProperties.$tutorial = ref(false);

  app.config.errorHandler = function (err, vm, info) {
	// `info` is a Vue-specific error info, e.g. which lifecycle hook
	// the error was found in. Only available in 2.2.0+
	console.error(err, vm, info);
  }

  app.use(router)
  app.use(Parallax)
  app.use(mitt)
  app.use(FloatingVue, { themes: {
    dropdown: { placement: window.innerWidth > 600 ? 'right' : 'top' },
  } })
  app.mount('#app');

  window.app = app;
  if(window.innerWidth < 600) {
	window.addEventListener('blur', e => {
		const audios = document.querySelectorAll('audio');
		audios.forEach(audio => {
			if(audio.paused === false) {
				audio.pause();
			}
		});
	});
  }

  if(window.innerWidth < 350 && window.orientation == 0) {
	document.querySelector('meta[name="viewport"]').setAttribute('content', 'user-scalable=no, initial-scale=0.7, maximum-scale=0.7, minimum-scale=0.7, width=device-width, height=device-height');
  }
}
